/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { InputBase, InputBaseProps } from '@mantine/core'
import { IMaskInput, IMaskInputProps } from 'react-imask'
import { useIntl } from 'react-intl'

export type RIBInputProps = InputBaseProps & IMaskInputProps<any>

function RIBInput (props: RIBInputProps) {
  const {
    value,
    ...others
  } = props

  const intl = useIntl()

  return (
    <InputBase
      component={IMaskInput}
      description={[
        intl.formatMessage({
          id: 'bank_code',
          defaultMessage: 'Code Banque'
        }),
        intl.formatMessage({
          id: 'counter_code',
          defaultMessage: 'Code Guichet'
        }),
        intl.formatMessage({
          id: 'account_number',
          defaultMessage: 'Numéro de compte'
        }),
        intl.formatMessage({
          id: 'key',
          defaultMessage: 'Clé'
        })
      ].join(' - ')}
      mask="00000 00000 00000000000 00"
      placeholder="00000 00000 00000000000 00"
      {...others}
      value={typeof value === 'string' ? value : ''}
    />
  )
}

export default RIBInput
